export default {
  state: {
    loggedUserVivamus: null,
  },
  mutations: {
    setLoggedUser(state, loggedUser) {
      state.loggedUserVivamus = loggedUser
    },
    clearUserLogged(state) {
      state.loggedUserVivamus = null
    },
  },
  actions: {
    async updateInfoLogged({ commit, getters }, toUpdate) {
      try {
        const updateData = { ...getters.loggedUser, ...toUpdate }
        commit('setLoggedUser', updateData)
      }

      catch (e) {
        commit('setError', e)
        throw e
      }
    },
  },
  getters: {
    loggedUserVivamus: s => s.loggedUserVivamus,
  }
}
